import styled from "styled-components";
import { Box } from "theme-ui";
import { themevals as theme } from "theme/themevals";

interface CustomProps {
  $submitting?: boolean;
  $errors?: any;
}

export const InputWrap = styled(Box)<CustomProps>`
  && {margin-bottom: 30px;}
  display: flex;
  flex-direction: column;
  position:relative;    
`;

export const labelStyles = {
  marginBottom: 0,
  display: "flex",
  justifyContent : "space-between",
  alignItems: "flex-end",
  fontSize: 12,
  fontWeight: 500,
  fontFamily:"Poppins"
};

export const LabelWrapper =  styled.div`
  margin-bottom: 8px;
  display: flex;
  width: 100%;
  label {
    color: ${theme.colors.dkgrey};
    ${labelStyles}
  }
  small {
    font-style: italic; font-size: .75rem; color: ${theme.colors.ltgrey};
  }
`;



export const Error = styled.div` 
  color:${theme.colors.danger};
  margin-top:10px; 
  font-size:12px;
  font-weight: 600;
  font-family:"Poppins";
  position:absolute;
  bottom:-25px;
`